import { FiMapPin, FiCompass, FiUsers, FiAward } from "react-icons/fi";
import { FaHandshake } from "react-icons/fa";
import GlobalPresence from "./GlobalPresence.jsx";
import GlobalPartners from "./GlobalPartners.jsx";

const partners = [
  "Chambers of Commerce — UK, Germany, France, Italy",
  "Industry Federations — Japan, South Korea, Singapore",
  "Business Councils — UAE, Saudi Arabia, Qatar",
  "Trade Bodies — USA, Canada, Australia",
  "African Chambers — Nigeria, South Africa, Kenya",
  "Latin American Councils — Brazil, Mexico, Colombia",
];

const reach = [
  { label: "Europe", val: "28+ Countries" },
  { label: "Asia Pacific", val: "18+ Countries" },
  { label: "Middle East", val: "12+ Countries" },
  { label: "Africa", val: "22+ Countries" },
  { label: "Americas", val: "16+ Countries" },
];

const pillars = [
  { icon: <FiUsers />, title: "Trade Missions", desc: "Inbound and outbound delegations connecting Indian industry with global decision-makers and buyers." },
  { icon: <FaHandshake />, title: "B2G Engagement", desc: "Direct dialogue with governments and regulators to shape favorable trade and investment policies." },
  { icon: <FiAward />, title: "Investment Forums", desc: "High-level forums that match Indian enterprises with international capital and strategic partners." },
];

export default function InternationalOutreach() {
  return (
    <section id="outreach" className="scroll-mt-28 space-y-16">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] px-8 py-14 md:px-16 md:py-20 shadow-2xl shadow-[#DB6400]/20">
        <div className="absolute -left-16 -top-16 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -right-20 -bottom-16 h-60 w-60 rounded-full bg-white/10 blur-2xl" />
        <div className="relative z-10 max-w-4xl">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md border border-white/10">
            <FiMapPin className="h-4 w-4" /> Global Network
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-semibold text-white leading-[0.95] tracking-tight">
            International <span className="italic font-normal">Outreach</span>
          </h2>
          <p className="mt-6 max-w-2xl text-lg text-white/90 leading-relaxed font-light">
            Expanding India's economic footprint through strategic partnerships, trade missions, and institutional collaborations across continents.
          </p>
        </div>
      </div>

      <GlobalPresence />

      {/* <GlobalPartners /> */}

      {/* <div className="grid gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2 rounded-3xl bg-[#FAF7F2] p-10 shadow-lg shadow-black/[0.03] border border-[#FEF7F4]">
          <h3 className="text-2xl font-semibold text-[#1a1a2e] mb-6 font-['Outfit'] tracking-tight">Strategic Partnerships</h3>
          <p className="text-[#4a4a5a] leading-relaxed mb-6">
            ASSOCHAM has signed Memoranda of Understanding (MoUs) with leading chambers of commerce and industry associations across Europe, Asia, Africa, the Americas, and Oceania. These partnerships enable direct access to local ecosystems, regulatory frameworks, and sector-specific networks.
          </p>
          <ul className="grid gap-3 sm:grid-cols-2">
            {partners.map((item) => (
              <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 border border-[#FEF7F4] shadow-sm">
                <span className="h-2 w-2 rounded-full bg-[#DA2128] flex-shrink-0" />
                <span className="text-sm font-medium text-[#2a2a3a]">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-3xl bg-gradient-to-b from-[#1a1a2e] to-[#2a2a40] p-10 text-white shadow-2xl shadow-black/20">
          <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-white shadow-lg backdrop-blur-sm">
            <FiCompass className="h-7 w-7" />
          </div>
          <h3 className="text-2xl font-semibold mb-4 font-['Outfit'] tracking-tight">Reach Across Continents</h3>
          <div className="space-y-6">
            {reach.map((r) => (
              <div key={r.label} className="flex justify-between items-center border-b border-white/10 pb-3">
                <span className="text-white/80">{r.label}</span>
                <span className="font-semibold text-[#F59C00]">{r.val}</span>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <div className="grid gap-6 md:grid-cols-3">
        {pillars.map((card) => (
          <div key={card.title} className="rounded-3xl bg-white border border-[#FEF7F4] p-8 shadow-xl shadow-black/[0.03] hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 group">
            <div className="mb-5 h-14 w-14 rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] text-white flex items-center justify-center text-xl shadow-lg shadow-[#DA2128]/25 group-hover:scale-110 transition-transform">
              {card.icon}
            </div>
            <h4 className="text-xl font-semibold text-[#1a1a2e] mb-3 font-['Outfit']">{card.title}</h4>
            <p className="text-[#6a6a7a] leading-relaxed">{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
